import { observer } from 'mobx-react';
import moment from 'moment';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DATE_YMD, SYSTEM_PATH } from '../../core/configs/constants';
import { useStore } from '../../core/utils/hook';
import NotFoundScreen from '../404/NotFoundScreen';
import { useState } from 'react';

const NotifyDetailScreen = observer(props => {

    // other
    const navigate = useNavigate();

    // params
    const { id } = useParams();

    // store
    const { notifyStore: { notify, getNotifyDetail } } = useStore();
    const [headerHeight, setHeaderHeight] = useState(0);
    useEffect(() => {
        const header = document.getElementById('header-site');
        if (!header) return;

        const updateHeight = () => {
            setHeaderHeight(header.offsetHeight);
        };

        // Follow initial height header
        updateHeight();

        // Follow resize header
        const resizeObserver = new ResizeObserver(updateHeight);
        resizeObserver.observe(header);

        // Follow resize window
        window.addEventListener('resize', updateHeight);

        return () => {
            resizeObserver.disconnect();
            window.removeEventListener('resize', updateHeight);
        };
    }, []);

    // lifecycle
    useEffect(() => {
        if(id) getNotifyDetail(id);
    }, [id])

    if(!id) return <NotFoundScreen/>

    return(
        <div id='main' className='wrapper notify-detail-screen main-Message-detail'>
            <div className="bres-cus" 
                style={{ position: 'sticky', zIndex: 50, top: `${headerHeight}px`, left: '0', width: '100%', backgroundColor: '#FFF'}}>
                <div className='container'>
                    <ul>
                        <li>
                            <a href={SYSTEM_PATH.HOME}>
                                <img src='/images/icon-home.png' alt='' />
                            </a>
                        </li>
                        {/* <li className='dash'>\</li>
                        <li>
                            <a href={SYSTEM_PATH.HOME}>お知らせ</a>
                        </li> */}
                        <li className='dash'>\</li>
                        <li>通知の詳細</li>
                    </ul>
                </div>
            </div>
            <div className='content-Message-detail'>
                <div className='container' style={{ height: '100%' }}>
                    <h1 className='title-primary'>{notify?.title}</h1>
                    <p className='date'>
                        {moment(notify?.createdAt).format(DATE_YMD)}
                    </p>
                    <div className='content-content pre-wrap' dangerouslySetInnerHTML={{__html: notify?.content}}></div>
                    <div className='footer d-flex align-items-center justify-content-between w-full'>
                        <div className='link-link'>
                            <button onClick={() => navigate(SYSTEM_PATH.HOME)}>ホーム画面へ</button>
                        </div>
                        <div>
                            <button className='navigate-to-notify-lst' onClick={() => navigate(SYSTEM_PATH.NOTIFY_LIST)}>一覧へ</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default NotifyDetailScreen;